import React, { useContext, useReducer } from "react";
import { arrayValidation } from '../helper/validation';
const fetchAssignedTestContext = React.createContext();

const reducer = (state, action) => {
  const { payload } = action
  switch (action.type) {
    case "ASSIGNED_TEST_DATA": {
      return {
        ...state, assignedTestData: payload,
        isAudioTestAssign: arrayValidation(payload.audio.data),
        isNonAudioTestAssign: arrayValidation(payload.non_audio.data),
        isTestAvailable: true,
        loader: false, err: false
      };
    }
    case "ASSIGNED_TEST_ERR": {
      return { ...state, err: true, loader: false };
    }
    case "ASSIGNED_TEST_LOADER": {
      return { ...state, loader: true };
    }
    case "TEST_AVAILABILITY": {
      return { ...state, isTestAvailable: action.payload, err: false, loader: false };
    }
    default:
      return state;
  }
};

export function AssignedTestProvider(props) {
  const initialValue = {
    assignedTestData: {},
    isAudioTestAssign: false, // individually check for audioTestAssign 
    isNonAudioTestAssign: false, // individually check for NonAudioTestAssign 
    isTestAvailable: true, // check for 404 No data found
    loader: true,
    err: false,
  };
  const [assignedTestC, dispatchAssignedTest] = useReducer(
    reducer,
    initialValue
  );
  return (
    <fetchAssignedTestContext.Provider
      value={{ assignedTestC, dispatchAssignedTest }}
      {...props}
    />
  );
}

export function FetchAssignedTestContext() {
  const context = useContext(fetchAssignedTestContext);
  if (!context) {
    throw new Error(" Please use the context inside parent scope");
  }
  return context;
}
